import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem
} from '@mui/material'
import { useState } from 'react'

import CheckConfiguration from './CheckConfiguration'

interface Props {
  closeMenu: () => void
}

const PrintLabel = ({ closeMenu }: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Dialog
        open={dialogOpen}
        fullWidth={true}
        maxWidth={'md'}
        onClose={() => setDialogOpen(false)}>
        <DialogTitle>Print Service Sticker</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Print a sticker to indicate when the customer should return for an
            oil change and/or an inspection!
          </DialogContentText>
          <Box padding={2} />
          <CheckConfiguration />
        </DialogContent>
        <DialogActions>
          <Button
            color="inherit"
            onClick={() => setDialogOpen(false)}
            sx={{ mr: 1 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <MenuItem
        onClick={() => {
          closeMenu()
          setDialogOpen(true)
        }}>
        {'Print Service Sticker'}
      </MenuItem>
    </>
  )
}

export default PrintLabel
